import { useRecoilState } from "recoil";
import { locationsState, memberState } from "../state/atoms";
import "./LocationDropdown.scss";
import { Button, Dropdown } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ChangeLocationIcon from "./icons/ChangeLocationIcon";
import { LocationDto } from "../generated/dashboard-client";
import { env } from "../env/env";
import {useRef} from "react";

interface AppAsideProps {
  location: LocationDto;
}

export default function LocationDropdown({ location }: AppAsideProps) {
  const navigate = useNavigate();
  const [locations] = useRecoilState(locationsState);
  const [member] = useRecoilState(memberState);
  const dropdownButton = useRef<HTMLButtonElement>(null);

  function goToLocations() {
    navigate(`${env.dashboardPath}/account/locations`);
  }

  function goToLocation(loc: LocationDto) {
    if (loc.internalId === location.internalId) return;
    let path = window.location.pathname;
    if (path.includes("link-pages")) {
      navigate(`${env.dashboardPath}/link-pages/${loc.internalId}`);
    } else if (path.includes("brand")) {
      navigate(`${env.dashboardPath}/brand/${loc.internalId}`);
    } else {
      navigate(`${env.dashboardPath}/designs/${loc.internalId}`);
    }

    dropdownButton.current?.click();
  }

  const menu = (
    <div className={"loc-drop-menu"}>
      <h6>Switch to another location</h6>
      <ul>
        {locations
          .map((it) => (
            <li key={it.id} className={it.internalId === location.internalId ? 'selected' : ''}>
              <div className={"lk"} onClick={() => goToLocation(it)}>
                <h6>{it.name}</h6>
                <p>
                  {it.address}
                  {it.city !== "" && (
                    <span>
                      <br />
                      {it.city}
                    </span>
                  )}
                  {it.state !== "" && <span>, {it.state}</span>}
                </p>
              </div>
            </li>
          ))}
      </ul>
      {member.owner && !member.clover && <footer>
        <Button className={"secondary-two"} onClick={goToLocations}>
          Manage Locations
        </Button>
      </footer>}
    </div>
  );

  return <>
    <Dropdown
      className={"loc-drop"}
      overlay={menu}
      getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
      trigger={["click"]}
    >
      <Button type={"link"} size={"large"} onClick={(e) => e.preventDefault()} ref={dropdownButton}>
        <div className={"icn"}>
          <ChangeLocationIcon />
        </div>
        <div className={"txt"}>
          <p className="loc-name">{location?.name}</p>
          <p className="loc-addr">{location?.address}</p>
        </div>
        <DownOutlined className={"carr"} />
      </Button>
    </Dropdown>
  </>;
}
